import { breakpoints } from './foundations/breakpoints';
import { progressStyles } from './components/progress';
import { textareaStyles } from './components/textarea';
import { CardComponent } from './additions/card/card';
import { buttonStyles } from './components/button';
import { sliderStyles } from './components/slider';
import { switchStyles } from './components/switch';
import { badgeStyles } from './components/badge';
import { inputStyles } from './components/input';
import { extendTheme } from '@chakra-ui/react';
import { linkStyles } from './components/link';
import { globalStyles } from './styles';

export default extendTheme(
  { breakpoints },
  globalStyles,
  badgeStyles,
  buttonStyles,
  linkStyles,
  progressStyles,
  sliderStyles,
  inputStyles,
  textareaStyles,
  switchStyles,
  CardComponent,
);
